export const GeneralIndicatorGraphType = 'GeneralIndicatorGraphType'
export const ProjectIndicatorGraphType = 'ProjectIndicatorGraphType'
